import React from 'react';
import moment from 'moment';

import { useGetDistributorSubscribersAllTimeInvestmentsQuery } from 'api/main';
import { parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import withProductSelect from './withProductSelectHOC';
import { CustomSelect, Loader } from 'components';
import { Box, MenuItem, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const nbsp = String.fromCharCode(160);

const useStyles = makeStyles(theme => ({
    paper: {
        height: '100%',
        padding: '52px 16px 16px 16px',
    },
}));

const SubscriptionValueData = props => {
    const { products, product, setProduct } = props;
    const classes = useStyles();

    const { data = { all_time_invested_sum: [] }, isFetching: loading } =
        useGetDistributorSubscribersAllTimeInvestmentsQuery({
            fundId: product === 'all' ? undefined : +product,
        });

    return (
        <Paper elevation={0} className={classes.paper}>
            <CustomSelect
                label={texts.PRODUIT}
                value={product}
                onChange={e => setProduct(e.target.value)}
            >
                <MenuItem value="all">{texts.ALL_1}</MenuItem>
                {products.map(f => (
                    <MenuItem key={f.id} value={f.id}>
                        {f.name}
                    </MenuItem>
                ))}
            </CustomSelect>
            <Loader loading={loading} mt={10}>
                <Box pt={13} display="flex" flexDirection="column" height="100%">
                    <Typography variant="h5" align="center" gutterBottom>
                        Au {moment().format(`DD${nbsp}MMMM${nbsp}YYYY`)}
                    </Typography>
                    <Typography variant="h5" align="center">
                        {texts.SUBSCRIPTIONS}
                        {nbsp}: {parseSum(+data?.all_time_invested_sum?.[0]?.value)}
                    </Typography>
                </Box>
            </Loader>
        </Paper>
    );
};

export default withProductSelect(SubscriptionValueData);
